import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faHome, faLock } from '@fortawesome/free-solid-svg-icons';

const Error403 = () => {
  return (
    <Card className="text-center">
      <Card.Body className="p-5">
        <div className="display-1 text-300 fs-error">403</div>

        <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
          Sie haben keine Berechtigung, auf diese Seite zuzugreifen.
        </p>

        <hr />

        <p>
          Bitte wenden Sie sich an einen Administrator oder kehren Sie zur
          Startseite zurück.
        </p>

        <Link className="btn btn-primary btn-sm mt-3" to="/app">
          <FontAwesomeIcon icon={faHome} className="me-2" />
          Zurück zur Startseite
        </Link>
      </Card.Body>
    </Card>
  );
};

export default Error403;
